import { render, staticRenderFns } from "./EspecialidadesTabelas.vue?vue&type=template&id=20508893"
import script from "./EspecialidadesTabelas.vue?vue&type=script&lang=js"
export * from "./EspecialidadesTabelas.vue?vue&type=script&lang=js"
import style0 from "./EspecialidadesTabelas.vue?vue&type=style&index=0&id=20508893&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports